import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import "./FeeTable.css";
import InstallmentData from "./InstallmentData";

const FeeTable = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggleInstallment = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const pendingEmiCount = (data) => {
    return data?.reduce((totalCount, elem) => {
      return totalCount + (elem.status === "paid" ? 0 : 1);
    }, 0);
  };

  return (
    <table className="fee-table">
      <tr className="fee-table-header">
        <th>Course/Package name</th>
        <th>Due/Payment/EMI date</th>
        <th>Pending Emi</th>
        <th>Price</th>
        <th></th>
      </tr>

      {data?.map((elem, index) => (
        <>
          <tr className="fee-table-row">
            <td className="course-program">
              <div className="program-name">{elem.program_name}</div>

              <div className="course-name"> {elem.course_name}</div>
            </td>
            <td className="date"></td>
            <td className="pending-emi">
              {pendingEmiCount(elem?.installments)}
            </td>
            <td className="fees">₹{elem.fees}</td>
            <td className="dropdown-icon">
              {elem?.installments.length > 0 &&
                (openIndex === index ? (
                  <ChevronUp
                    onClick={() => handleToggleInstallment(index)}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <ChevronDown
                    onClick={() => handleToggleInstallment(index)}
                    style={{ cursor: "pointer" }}
                  />
                ))}
            </td>
          </tr>
          {openIndex == index && <InstallmentData data={elem?.installments} />}
        </>
      ))}
    </table>
  );
};

export default FeeTable;
